import controller from './category.controller';
import templateBase from './templates/category-base.view.html';
import templateAd from './templates/category-adaptative.view.html';
import templateT1 from './templates/category-t1.view.html';
import templateT2 from './templates/category-t2.view.html';
import templateT3 from './templates/category-t3.view.html';
import templateT4 from './templates/category-t4.view.html';
import templateT10 from './templates/category-t10.view.html';
import templateT11 from './templates/category-t11.view.html';
import templateT13 from './templates/category-t13.view.html';

let CategoryComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAd
  }else{
  if (response.CATEGORY.component == 'template_t1') {
    return templateT1;
  } else if (response.CATEGORY.component == 'template_t2') {
    return templateT2;
  } else if (response.CATEGORY.component == 'template_t3') {
    return templateT3;
  } else if (response.CATEGORY.component == 'template_t4') {
    return templateT4;
  } else if (response.CATEGORY.component == 'template_t10') {
    return templateT10;
  } else if (response.CATEGORY.component == 'template_t11') {
    return templateT11;
  } else if (response.CATEGORY.component == 'template_t13') {
    return templateT13;
  }
  else {
    return templateBase;
  }

}

}

export default CategoryComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category.component.js
 **/